// removed by extract-text-webpack-plugin
module.exports = {"outerWrapper":"src-components-Messages-styles-__ExpandedMediaModal__outerWrapper--1C4Uc","closeButton":"src-components-Messages-styles-__ExpandedMediaModal__closeButton--3IN8G","greyBg":"src-components-Messages-styles-__ExpandedMediaModal__greyBg--jKKJ3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/styles/ExpandedMediaModal.css
// module id = 462
// module chunks = 0